import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/promotion-program";

export const searchByPagePromotionProgram = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getPromotionProgramById = (serviceVatId) => axios.get(API_PATH + "/get-by-id/" + serviceVatId);

export const saveOrUpdatePromotionProgram = serviceVat => axios.post(API_PATH + "/save-or-update", serviceVat);

export const deletePromotionProgram = serviceVatId => axios.delete(API_PATH + '/mark-delete/' + serviceVatId);

